import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classify from '../../classify';
import defaultClasses from './mask.css';

/**
 * A component that masks content.
 *
 * @class Mask
 * @extends {Component}
 *
 * @typedef Mask
 * @kind class component
 *
 * @returns {React.Element} A React component that will mask content.
 */
class Mask extends Component {
  render() {
    var {
      classes,
      dismiss,
      isActive
    } = this.props;
    var className = isActive ? classes.root_active : classes.root;
    return /*#__PURE__*/React.createElement("button", {
      className: className,
      onClick: dismiss
    });
  }
}
/**
 * Props for {@link Mask}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the
 * Mask component.
 * @property {string} classes.root classes for root container
 * @property {string} classes.root_action classes for root container if
 * the `isActive` property is `true`.
 * @property {Function} dismiss the handler for on the `onClick` event
 * handler.
 * @property {boolean} isActive whether the mask is in an active state
 * or not.
 */
_defineProperty(Mask, "propTypes", {
  classes: PropTypes.shape({
    root: PropTypes.string,
    root_active: PropTypes.string
  }),
  dismiss: PropTypes.func,
  isActive: PropTypes.bool
});
export default classify(defaultClasses)(Mask);